<template lang="html">
  <div class="menuItemHeadMobileMenu">
    <div class="menuItemTitleMobileMenu">
      <span v-if="labelId && labelId !== ''">{{ $t(labelId) }}</span>
      <span v-else>{{ label }}</span>
    </div>
    <div class="menuItemSubBarMobileMenu"/>
  </div>
</template>

<script>
export default {
  name: 'MobileMenuSectionHeader',
  props: [
    /** Label to display */
    'label',
    /** i18n label ID used to display */
    'labelId'
  ]
}
</script>
